module.exports = __webpack_public_path__ + "img/shipping agent.80293250.png";